export function replaceDotWithComma(value: number | string): string {
  return String(value)?.replace('.', ',')
}

export const npsColors = {
  detractors: '#FD4949',
  neutral: '#FCBD2F',
  promoters: '#3ACB23',
  none: '#898989'
}

export function handleDataColor(value: number | string): string {
  const detractorsReference = 69.9
  const promotersReference = 90.0

  if (value <= detractorsReference) {
    return npsColors.detractors
  }

  if (value > detractorsReference && value < promotersReference) {
    return npsColors.neutral
  }

  if (value >= promotersReference) {
    return npsColors.promoters
  }

  return npsColors.none
}